/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ThermometerCold(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M244.90576,77.71973l-19.96167,6.48632,12.33716,16.98047a8,8,0,1,1-12.94434,9.4043L212,93.61035l-12.33691,16.98047a7.99995,7.99995,0,0,1-12.94434-9.4043l12.33716-16.98047-19.96167-6.48632a8,8,0,1,1,4.94433-15.2168L204,68.98877V48a8,8,0,0,1,16,0V68.98877l19.96143-6.48584a8,8,0,1,1,4.94433,15.2168ZM180,188A60,60,0,1,1,80,143.27441V48a40,40,0,0,1,80,0v95.27441A59.61666,59.61666,0,0,1,180,188ZM96,48v56h48V48a24,24,0,0,0-48,0Z" />
    </Svg>
  );
}

export default ThermometerCold;
